
import { useMessage } from "./message_context";
import { useToken } from "./token_context";
import { useState } from 'react';

export function CreateNewDataBaseModal() {
    const { token } = useToken();
    const { setMessage } = useMessage();

    const [buttonText, setButtonText] = useState("OK");

    async function onClick_OK(evt) {
        evt.preventDefault();
        if (buttonText == "OK") {
            setButtonText("3");
        } else if (buttonText == "1") {
            const rc = await createNewDataBase();
            console.log(rc);
        } else {
            setButtonText(parseInt(buttonText) - 1);
        };
    };

    async function createNewDataBase() {

        fetch("/api/create_new_database", {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                _t: token.token
            })
        }).then(response => response.json())
        .then(rc => {
            if (rc.rc == "ok")
                document.getElementById('create_new_database_modal').close();
                setMessage({message: "Database created", type: "ok", description: ""});
        } );

    };

    return (
        <dialog id="create_new_database_modal" className="modal bg-red">

          <div className="modal-box">
            <h3 className="font-bold text-lg py-2">Create new Database: Are you sure?</h3>

            <p className="label">All submitted data will be lost!!!</p>
            <div className="m-4">
                Options:
                <ul className="list-disc m-4">
                    <li>Upgrade Databse</li>
                    <li>Download Databse</li>
                    <li>Upload Database</li>
                </ul>
            </div>

            <div className="modal-action">
              <form method="dialog">
                <button className="btn btn-error mx-2" onClick={onClick_OK} >{buttonText}</button>
                <button className="btn btn-success mx-2">NO!!! Take me back to safety!</button>
              </form>
            </div>
          </div>
        </dialog>
      );
}

export function CreateNewDataBaseAction(evt) {
    document.getElementById('create_new_database_modal').showModal();
};

